module.exports = __webpack_public_path__ + "static/media/about.64203156.jfif";